import React from "react";
import {
    DangerAlertBanner, AlertActionBtn,
    DangerSection, DangerHeader, DangerBody, DangerTimeline, DangerEntry,
    ReportDangerBtn,
    DialogOverlay, DialogBox, DialogHeader, DialogBody, DialogFooter,
    DialogCloseBtn, DialogBtn, FormField,
} from "./BirthPreparednessStyles";

/**
 * DangerSignsPanel — Shows active danger sign alerts, history, and report form
 */
export const DangerSignsPanel = function(props) {
    const dangerSigns = props.dangerSigns;
    const activeDangerSigns = props.activeDangerSigns;
    const loadingDanger = props.loadingDanger;
    const dangerForm = props.dangerForm;
    const handleDangerFormChange = props.handleDangerFormChange;
    const openDangerDialog = props.openDangerDialog;
    const closeDangerDialog = props.closeDangerDialog;
    const submitDangerSign = props.submitDangerSign;
    const savingDanger = props.savingDanger;
    const dangerDialog = props.dangerDialog;
    const DANGER_SIGNS = props.DANGER_SIGNS;

    /* ─── Lookup helpers ─── */
    const getSignDef = function(key) {
        return DANGER_SIGNS.find(function(s) { return s.key === key; }) || {};
    };

    return React.createElement("div", null,
        /* ═══ Active Danger Signs Alert Banner ═══ */
        activeDangerSigns.length > 0 ? React.createElement(DangerAlertBanner, null,
            React.createElement("div", { className: "alert-icon" }, "🚨"),
            React.createElement("div", { className: "alert-text" },
                React.createElement("div", { className: "alert-title" },
                    activeDangerSigns.length + " Active Danger Sign" +
                    (activeDangerSigns.length > 1 ? "s" : "") + " Reported"
                ),
                React.createElement("div", { className: "alert-desc" },
                    activeDangerSigns.map(function(ds) {
                        const def = getSignDef(ds.danger_sign);
                        return def.label || ds.danger_sign;
                    }).join(", ")
                )
            ),
            React.createElement(AlertActionBtn, {
                onClick: function() { openDangerDialog(""); },
            }, "Report New")
        ) : null,

        /* ═══ Report Button (when no active alerts) ═══ */
        activeDangerSigns.length === 0 ? React.createElement("div", {
            style: { marginBottom: 20, display: "flex", justifyContent: "flex-end" }
        },
            React.createElement(ReportDangerBtn, {
                onClick: function() { openDangerDialog(""); },
            },
                "🚨 Report Danger Sign"
            )
        ) : null,

        /* ═══ Danger Signs History ═══ */
        React.createElement(DangerSection, null,
            React.createElement(DangerHeader, null,
                React.createElement("h4", null, "⚠ Reported Danger Signs History"),
                React.createElement("span", {
                    style: { fontSize: "0.78rem", color: "#b71c1c", fontWeight: 600 }
                }, dangerSigns.length + " total")
            ),
            React.createElement(DangerBody, null,
                loadingDanger ? React.createElement("div", {
                    style: { padding: "20px", textAlign: "center", color: "#90a4ae", fontSize: "0.85rem" }
                }, "⏳ Loading danger signs...") : null,

                !loadingDanger && dangerSigns.length === 0 ? React.createElement("div", {
                    style: { padding: "30px 20px", textAlign: "center", color: "#90a4ae" }
                },
                    React.createElement("div", { style: { fontSize: "2rem", marginBottom: 8 } }, "✅"),
                    React.createElement("div", { style: { fontSize: "0.88rem", fontWeight: 600, color: "#546e7a" } },
                        "No Danger Signs Reported"
                    ),
                    React.createElement("div", { style: { fontSize: "0.8rem" } },
                        "This is good! Continue monitoring and counselling at each visit."
                    )
                ) : null,

                !loadingDanger && dangerSigns.length > 0 ? React.createElement(DangerTimeline, null,
                    dangerSigns.slice().reverse().map(function(ds, idx) {
                        const def = getSignDef(ds.danger_sign);
                        const isResolved = ds.outcome && ds.outcome !== "" && ds.outcome !== "pending";
                        return React.createElement(DangerEntry, {
                            key: ds.id || idx,
                            severity: def.severity || "medium",
                            resolved: isResolved,
                        },
                            React.createElement("div", { className: "de-icon" }, def.icon || "⚠"),
                            React.createElement("div", { className: "de-content" },
                                React.createElement("div", { className: "de-title" },
                                    def.label || ds.danger_sign
                                ),
                                React.createElement("div", { className: "de-meta" },
                                    "Reported: " + (ds.reported_date || "N/A") +
                                    (def.severity === "critical" ? " · 🔴 CRITICAL" : "")
                                ),
                                ds.action_taken ? React.createElement("div", { className: "de-action" },
                                    "Action: " + ds.action_taken
                                ) : null,
                                React.createElement("span", { className: "de-outcome" },
                                    isResolved ? "✓ " + ds.outcome : "⏳ Pending"
                                )
                            )
                        );
                    })
                ) : null
            )
        ),

        /* ═══ Quick Reference: Danger Signs ═══ */
        React.createElement(DangerSection, null,
            React.createElement(DangerHeader, null,
                React.createElement("h4", null, "📖 Danger Signs Quick Reference")
            ),
            React.createElement(DangerBody, null,
                React.createElement("div", {
                    style: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", gap: 10 }
                },
                    DANGER_SIGNS.map(function(sign) {
                        return React.createElement("div", {
                            key: sign.key,
                            style: {
                                display: "flex", alignItems: "center", gap: 10,
                                padding: "10px 14px", borderRadius: 8,
                                background: sign.severity === "critical" ? "#ffebee" :
                                    sign.severity === "high" ? "#fff3e0" : "#fff8e1",
                                border: "1px solid " + (sign.severity === "critical" ? "#ef9a9a" :
                                    sign.severity === "high" ? "#ffcc80" : "#ffe082"),
                            }
                        },
                            React.createElement("span", { style: { fontSize: "1.2rem" } }, sign.icon),
                            React.createElement("div", null,
                                React.createElement("div", {
                                    style: { fontSize: "0.82rem", fontWeight: 600, color: "#263238" }
                                }, sign.label),
                                React.createElement("div", {
                                    style: { fontSize: "0.72rem", color: "#78909c" }
                                }, sign.description),
                                React.createElement("span", {
                                    style: {
                                        fontSize: "0.65rem", fontWeight: 600, textTransform: "uppercase",
                                        color: sign.severity === "critical" ? "#c62828" :
                                            sign.severity === "high" ? "#e65100" : "#f9a825",
                                    }
                                }, sign.severity)
                            )
                        );
                    })
                )
            )
        ),

        /* ═══ Report Danger Sign Dialog ═══ */
        dangerDialog ? React.createElement(DialogOverlay, {
            onClick: function(e) { if (e.target === e.currentTarget) closeDangerDialog(); }
        },
            React.createElement(DialogBox, null,
                React.createElement(DialogHeader, null,
                    React.createElement("h4", null, "🚨 Report Danger Sign"),
                    React.createElement(DialogCloseBtn, { onClick: closeDangerDialog }, "×")
                ),
                React.createElement(DialogBody, null,
                    /* Danger sign select */
                    React.createElement(FormField, null,
                        React.createElement("label", null, "Danger Sign"),
                        React.createElement("select", {
                            value: dangerForm.danger_sign || "",
                            onChange: function(e) { handleDangerFormChange("danger_sign", e.target.value); },
                        },
                            React.createElement("option", { value: "" }, "— Select danger sign —"),
                            DANGER_SIGNS.map(function(sign) {
                                return React.createElement("option", {
                                    key: sign.key, value: sign.key,
                                }, sign.icon + " " + sign.label + " (" + sign.severity + ")");
                            })
                        )
                    ),

                    /* Date reported */
                    React.createElement(FormField, null,
                        React.createElement("label", null, "Date Reported"),
                        React.createElement("input", {
                            type: "date",
                            value: dangerForm.reported_date || "",
                            onChange: function(e) { handleDangerFormChange("reported_date", e.target.value); },
                        })
                    ),

                    /* Action taken */
                    React.createElement(FormField, null,
                        React.createElement("label", null, "Action Taken"),
                        React.createElement("textarea", {
                            rows: 3,
                            placeholder: "Describe the action taken (e.g., referred to hospital, given medication...)",
                            value: dangerForm.action_taken || "",
                            onChange: function(e) { handleDangerFormChange("action_taken", e.target.value); },
                        })
                    ),

                    /* Outcome */
                    React.createElement(FormField, null,
                        React.createElement("label", null, "Outcome"),
                        React.createElement("select", {
                            value: dangerForm.outcome || "",
                            onChange: function(e) { handleDangerFormChange("outcome", e.target.value); },
                        },
                            React.createElement("option", { value: "" }, "— Select outcome —"),
                            React.createElement("option", { value: "pending" }, "Pending / Under observation"),
                            React.createElement("option", { value: "resolved" }, "Resolved"),
                            React.createElement("option", { value: "referred" }, "Referred to higher facility"),
                            React.createElement("option", { value: "admitted" }, "Admitted"),
                            React.createElement("option", { value: "delivered" }, "Emergency delivery"),
                            React.createElement("option", { value: "other" }, "Other")
                        )
                    )
                ),
                React.createElement(DialogFooter, null,
                    React.createElement(DialogBtn, { onClick: closeDangerDialog }, "Cancel"),
                    React.createElement(DialogBtn, {
                        variant: "danger",
                        disabled: savingDanger || !dangerForm.danger_sign,
                        onClick: submitDangerSign,
                    },
                        savingDanger ? "Reporting..." : "⚠ Report Danger Sign"
                    )
                )
            )
        ) : null
    );
};
